import {mergeDeep} from '@/lib/helper/helper.js'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum.js'

export default {
  data() {
    return {
      pollingOptions: {
        timeout : 5000,
        interval: null
      }
    }
  },

  computed: {
    pollingTransactionsFiltered() {
      return this.transactions
        ?.filter(transaction => PaymentTypeEnum.isEftPosPaymentType(transaction.PaymentType))
        ?.filter(transaction => transaction.WaitingPos || transaction.busy)
        ?.filter(transaction => !transaction?.External)
    },

    pollingTransactionsMapped() {
      return this.pollingTransactionsFiltered
        ?.map(transaction => transaction.TransactionId)
    },

    hasTransactionsForPolling() {
      return this.pollingTransactionsMapped.length > 0
    },

    canStartTransactionsPolling() {
      return this.appHasFiscalDocsProvider && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD && this.hasTransactionsForPolling
    }
  },

  created() {
    this.startTransactionsPolling()
  },

  beforeDestroy() {
    this.stopTransactionsPolling()
  },

  watch: {
    canStartTransactionsPolling(newVal) {
      if (newVal) {
        this.startTransactionsPolling()
      } else {
        this.stopTransactionsPolling()
        this.$bus.$emit('add-payment-loader-stop')
      }
    }
  },

  methods: {
    startTransactionsPolling() {
      if (!this.canStartTransactionsPolling) return

      this.stopTransactionsPolling()
      this.pollingOptions.interval = setInterval(this.getTransactionsResult, this.pollingOptions.timeout)
      this.$bus.$on(window.SocketCommand.Payment.EftPos.Result, this.getTransactionsResultResponse)
    },

    stopTransactionsPolling() {
      if (this.pollingOptions.interval) clearInterval(this.pollingOptions.interval)
      this.$bus.$off(window.SocketCommand.Payment.EftPos.Result, this.getTransactionsResultResponse)
    },

    getTransactionsResult() {
      window.callAS(window.SocketCommand.Payment.EftPos.Result, {
        OrderId     : this.orderId || null,
        CartId      : this.table?.CartId || this.cartId || null,
        Transactions: this.pollingTransactionsMapped
      })
    },

    getTransactionsResultResponse(response) {
      if (!response || !Array.isArray(response) || !response?.length) return

      for (let i = 0; i < response.length; i++) {
        const responseTransaction = response[i]
        const transactionIndex = this.transactions?.findIndex(t => t.TransactionId === responseTransaction.TransactionId)

        if (transactionIndex > -1) {
          const transaction = mergeDeep(this.transactions[transactionIndex], responseTransaction ?? {})

          this.$set(this.transactions[transactionIndex], 'WaitingPos', transaction?.WaitingPos)
          this.$set(this.transactions[transactionIndex], 'ResponseIntentResult', transaction?.ResponseIntentResult)
          this.$set(this.transactions[transactionIndex], 'ResponseIntentStatus', transaction?.ResponseIntentStatus)
          this.$set(this.transactions[transactionIndex], 'Status', transaction?.Status)
          this.$set(this.transactions[transactionIndex], 'Paid', transaction?.Paid)
          this.$set(this.transactions[transactionIndex], 'OrderCode', transaction?.OrderCode)

          if (transaction.WaitingPos === false) {
            this.setTransactionBusy(this.transactions[transactionIndex], false, 0)
          }
        }
      }
    }
  }
}
